import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../lib/auth";

/** Gates child routes: renders nothing while loading, redirects to /login when logged out. */
export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="page-center">
        <p className="muted">Loading…</p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

/** The inverse: sends logged-in users away from /login and /signup. */
export function RedirectIfAuthed() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/stories" replace />;
  return <Outlet />;
}

/** "/" → /stories when logged in, else /login. */
export function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/stories" : "/login"} replace />;
}
